import { cn } from '@/lib/cn';
import type { BookingStatus, CreativeStatus } from '@/api/ads/types';

const statusStyles: Record<string, string> = {
  draft: 'bg-muted text-muted-foreground',
  pending_payment: 'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400',
  pending_review: 'bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400',
  approved: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400',
  live: 'bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-400',
  completed: 'bg-slate-200 text-slate-700 dark:bg-slate-500/20 dark:text-slate-300',
  rejected: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400',
  cancelled: 'bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-400',
  pending: 'bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400',
  active: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400',
  suspended: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400',
};

export function Badge({
  children,
  status,
  className,
}: {
  children: React.ReactNode;
  status?: BookingStatus | CreativeStatus | string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium capitalize',
        status ? statusStyles[status] ?? 'bg-muted text-muted-foreground' : 'bg-muted text-muted-foreground',
        className,
      )}
    >
      {children}
    </span>
  );
}
